import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { success } from 'daisyui/src/colors';




const Contact = () => {
    const form = useRef();


    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_f4330p6', 'template_06l84hp', form.current, 'P7950myh5qvDIqce_')
            .then((result) => {
                toast('successfully sended');
            }, (error) => {
                toast('problem to send message');
            });
        e.target.reset()
    };

    return (
        <div class="card w-96 bg-base-100 shadow-xl mx-auto">
            <div class="card-body">
                <h2 class="text-xl font-bold text-center">Contact With Me</h2>
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name='name' placeholder='your name' required class="input mt-2 input-bordered input-primary w-full max-w-xs" />
                    <input type="text" name='email' placeholder='your email' required class="input mt-2 input-bordered input-primary w-full max-w-xs" />
                    <textarea name='message' class="textarea mt-2 textarea-primary" required placeholder="Your massege"></textarea>
                    <input className='btn btn-primary w-full mt-2' type="submit" value='Send' />
                </form>

            </div>
            <ToastContainer></ToastContainer>
        </div>
    );
};

export default Contact;